import script from "./lottery.vue?vue&type=script&setup=true&lang=js"
export * from "./lottery.vue?vue&type=script&setup=true&lang=js"

import "./lottery.vue?vue&type=style&index=0&id=1ce60266&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ce60266"]])

export default __exports__